module.exports = __webpack_public_path__ + "static/media/seguro.067d5919.png";